<script setup lang="ts">
defineProps<{
    sidebarCollapsed: boolean
}>()
</script>

<template>
    <header
        :class="[
            'fixed top-0 right-0 h-th bg-white border-b border-gray-200 z-sticky',
            'flex items-center px-4 gap-2 transition-[left] duration-normal',
            // Mobile: header spans full width (sidebar is overlay).
            // Desktop (lg+): leave space for sidebar — collapsed vs expanded.
            'left-0',
            sidebarCollapsed ? 'lg:left-sw-c' : 'lg:left-sw'
        ]"
    >
        <slot name="sidebar-toggle" />
        <div class="flex-1 min-w-0">
            <slot name="breadcrumb" />
        </div>
        <div class="flex items-center gap-3">
            <slot name="instance-switcher" />
            <slot name="user-menu" />
        </div>
    </header>
</template>
